// External deps
import React from "react";
import { Redirect, Switch, Route } from "react-router-dom";

// Internal deps
import NavBar from "../components/NavBar/NavBar";
import PageNotFound from "../pages/PageNotFound";
import Login from "../pages/Login";
import useApp from "../hooks/useApp";
import Home from "../pages/Home";

const Routes = () => {
  const { auth } = useApp();

  if (!auth) {
    return <Login />;
  }

  return (
    <>
      {!auth ? (
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route exact path="/" component={Login} />
          <Route exact path="/*">
            <Redirect to="/" />
          </Route>
        </Switch>
      ) : (
        <>
          <NavBar />
          <Switch>
            <Route exact path="/home" component={Home} />
            <Redirect exact path="/" to="/home" />
            <Redirect exact path="/login" to="/home" />
            <Route exact path="/notFound" component={PageNotFound} />
          </Switch>
        </>
      )}
    </>
  );
};

export default Routes;
